import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { forwardRef } from "react";
import { clsx } from "clsx";
/* empty css          */
const UnStyledButton = forwardRef((props, ref) => {
  const $ = c(6);
  let t0;
  if ($[0] !== props.className) {
    t0 = clsx("graphiql-un-styled", props.className);
    $[0] = props.className;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props || $[3] !== ref || $[4] !== t0) {
    t1 = /* @__PURE__ */ jsx("button", { ...props, ref, className: t0 });
    $[2] = props;
    $[3] = ref;
    $[4] = t0;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
});
UnStyledButton.displayName = "UnStyledButton";
const Button = forwardRef((props, ref) => {
  const $ = c(8);
  const t0 = props.variant === "primary" && "graphiql-button-primary";
  let t1;
  if ($[0] !== props.className || $[1] !== props.state || $[2] !== t0) {
    t1 = clsx("graphiql-button", t0, {
      success: "graphiql-button-success",
      error: "graphiql-button-error"
    }[props.state], props.className);
    $[0] = props.className;
    $[1] = props.state;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== props || $[5] !== ref || $[6] !== t1) {
    t2 = /* @__PURE__ */ jsx("button", { ...props, ref, className: t1 });
    $[4] = props;
    $[5] = ref;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
});
Button.displayName = "Button";
export {
  Button,
  UnStyledButton
};
//# sourceMappingURL=index.js.map
